import React from "react";
import { Link } from "react-router-dom";

export const CONTACT_EMAIL = "yzmatematik@gmail.com";

export function LegalLinks({ dark = false, className = "" }) {
  const cls = dark ? "text-white/60 hover:text-white" : "text-slate-500 hover:text-[#0B1A35]";
  return (
    <nav className={`flex items-center justify-center gap-4 text-xs ${className}`} data-testid="legal-links">
      <Link to="/privacy" className={`${cls} hover:underline transition-colors`} data-testid="legal-link-privacy">Gizlilik Politikası</Link>
      <span className={dark ? "text-white/30" : "text-slate-300"}>·</span>
      <Link to="/terms" className={`${cls} hover:underline transition-colors`} data-testid="legal-link-terms">Kullanım Koşulları</Link>
    </nav>
  );
}

export function LegalLayout({ title, updated, children, testId }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid={testId}>
      <header className="bg-[#061226]">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <img src="/brand/yz-icon.png" alt="YZ Matematik" className="h-9 w-9 rounded-full ring-1 ring-[#F5B301]/60" />
            <span className="font-display text-lg tracking-tight">
              <span className="text-white">YZ</span> <span className="text-[#F5B301]">Matematik</span>
            </span>
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8 sm:py-12">
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight text-[#0B1A35]">{title}</h1>
        <p className="text-xs text-slate-500 mt-2">Son güncelleme: {updated}</p>
        <article className="mt-8 space-y-6 text-[15px] leading-relaxed text-slate-700 legal-content">
          {children}
        </article>
      </main>
      <footer className="border-t border-[#E2E8F0] py-6">
        <LegalLinks />
        <p className="text-center text-[11px] text-slate-400 mt-2">© YZ Matematik</p>
      </footer>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="font-display text-lg text-[#0B1A35]">{title}</h2>
      {children}
    </section>
  );
}
